<div class="carousel-container">
    <div class="carousel-wrapper" [style.transform]="'translateX(-' + currentIndex * 100 + '%)'">
      <div class="carousel-item" *ngFor="let image of images">
        <img [src]="image.url" [alt]="image.caption" (click)="openFullscreen(image)">
        <div class="caption" *ngIf="image.caption">{{ image.caption }}</div>
      </div>
    </div>
  
    <button class="carousel-btn prev" (click)="prevSlide()" [disabled]="currentIndex === 0">
      ‹
    </button>
    <button class="carousel-btn next" (click)="nextSlide()" [disabled]="currentIndex === images.length - 1">
      ›
    </button>
  </div>
  